import { render, staticRenderFns } from "./WebhookIntegration.vue?vue&type=template&id=c482a20e"
import script from "./WebhookIntegration.vue?vue&type=script&lang=js"
export * from "./WebhookIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports